import React, { useState } from 'react';
import './Gallerysection.css';

const faqsList = [
  {
    q: "What is N D Connect?",
    a: "N D Connect is an all-in-one business management platform designed to streamline your operations. It covers everything from customer management and invoicing to employee attendance tracking and payment reminders, all within one intuitive software."
  },
  {
    q: "Who can benefit from using N D Connect?",
    a: "N D Connect is ideal for businesses of all sizes across various industries. Whether you're a small startup or a large enterprise, our platform adapts to your specific needs, helping you manage your business more effectively."
  },
  {
    q: "How does the location-based attendance system work?",
    a: "Our attendance system integrates with Google Maps to verify employees' locations when they log in. Companies can set a specific location radius, and if an employee tries to clock in outside of this area, they won't be able to do so. This ensures accurate attendance records and helps prevent fraudulent logins."
  },
  {
    q: "Can I customize N D Connect to fit my business needs?",
    a: "Yes, N D Connect is highly customizable. We understand that every business is unique, so our platform allows you to tailor its features to match your specific requirements."
  },
  {
    q: "How secure is my data on N D Connect?",
    a: "Security is our top priority. N D Connect uses advanced encryption and security protocols to protect your data. We also offer regular backups and secure access controls to ensure that your information is safe."
  },
  {
    q: "What kind of support do you offer?",
    a: "We provide comprehensive support to all our customers. Whether you need help with setup, customization, or troubleshooting, our dedicated support team is here to assist you every step of the way."
  },
  {
    q: "Can I try N D Connect before committing?",
    a: "Absolutely! We offer a free demo of N D Connect so you can explore its features and see how it can benefit your business. Contact us to schedule your demo today."
  }
];

const additionalDetailsList = [
  {
    q: "What is Real-Time Analytics and Reporting?",
    a: "With N D Connect, you can make data-driven decisions with confidence. Our platform provides real-time analytics and customizable reports, giving you valuable insights into your business operations. Track performance, monitor trends, and identify opportunities for growth with ease."
  },
  {
    q: "What are Scalable Solutions for Growing Businesses?",
    a: "As your business grows, N D Connect grows with you. Our platform is designed to scale effortlessly, ensuring that you can continue to manage your expanding operations without any disruptions."
  },
  {
    q: "How does N D Connect integrate with popular tools?",
    a: "N D Connect seamlessly integrates with popular tools and platforms like Google Workspace, QuickBooks, and more. This allows you to maintain your existing workflows while enhancing your capabilities with our software."
  },
  {
    q: "What automation features does N D Connect offer?",
    a: "Save time and reduce manual errors with N D Connect's automation features. From sending payment reminders to generating salary slips, our platform automates repetitive tasks, freeing up your team to focus on more strategic activities."
  },
  {
    q: "How does Mobile Access work with N D Connect?",
    a: "Stay connected to your business from anywhere. N D Connect is accessible via mobile devices, allowing you to manage your operations on the go. Whether you're traveling or working remotely, you have full control at your fingertips."
  },
  {
    q: "What is the process for Tailored Onboarding and Training?",
    a: "We understand that adopting new software can be daunting. That's why we offer tailored onboarding and training sessions to ensure a smooth transition. Our experts will guide you through the setup process and provide training to your team, so you can get the most out of N D Connect."
  },
  {
    q: "What are the Affordable Pricing Plans for N D Connect?",
    a: "N D Connect offers flexible pricing plans to suit businesses of all sizes. We believe in providing value, so our plans are designed to be affordable without compromising on quality or features. Contact us to discuss a plan that works best for your business."
  }
];

const Gallerysection = () => {
    const [openFaqIndex, setOpenFaqIndex] = useState(0);
    const [openDetailIndex, setOpenDetailIndex] = useState(0);

    const toggleFaq = (index) => {
        setOpenFaqIndex(openFaqIndex === index ? null : index);
    };

    const toggleDetail = (index) => {
        setOpenDetailIndex(openDetailIndex === index ? null : index);
    };

    return (
        <section className="nd-faq-section">
            <div className="container">
                <div className="row justify-content-center text-center mb-5">
                    <div className="col-lg-8">
                        <div className="nd-section-badge">
                            <i className="fa fa-question-circle me-2"></i>
                            <span>Help & Clarity</span>
                        </div>
                        <h2 className="nd-faq-main-title">
                            Questions & <span className="nd-gradient-text">Detailed Insights</span>
                        </h2>
                        <p className="nd-faq-main-subtitle">
                            Everything you need to know about N D Connect, security, features, and platform capabilities.
                        </p>
                    </div>
                </div>

                <div className="row g-5">
                    {/* Left Column: FAQs */}
                    <div className="col-lg-6">
                        <div className="nd-faq-column-card">
                            <div className="nd-column-header">
                                <div className="nd-col-icon">
                                    <i className="fa fa-comments"></i>
                                </div>
                                <h3>Frequently Asked Questions</h3>
                            </div>

                            <div className="nd-accordion-list">
                                {faqsList.map((item, idx) => {
                                    const isOpen = openFaqIndex === idx;
                                    return (
                                        <div 
                                            key={idx} 
                                            className={`nd-accordion-item ${isOpen ? 'active' : ''}`}
                                        >
                                            <button 
                                                className="nd-accordion-btn"
                                                onClick={() => toggleFaq(idx)}
                                                aria-expanded={isOpen}
                                            >
                                                <span>{item.q}</span>
                                                <div className="nd-accordion-icon">
                                                    <i className={`fa ${isOpen ? 'fa-minus' : 'fa-plus'}`}></i>
                                                </div>
                                            </button>
                                            <div className={`nd-accordion-collapse ${isOpen ? 'show' : ''}`}>
                                                <div className="nd-accordion-body">
                                                    <p>{item.a}</p>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    {/* Right Column: Additional Details */}
                    <div className="col-lg-6">
                        <div className="nd-faq-column-card">
                            <div className="nd-column-header">
                                <div className="nd-col-icon nd-icon-secondary">
                                    <i className="fa fa-chart-line"></i>
                                </div>
                                <h3>Additional Details</h3>
                            </div>

                            <div className="nd-accordion-list">
                                {additionalDetailsList.map((item, idx) => {
                                    const isOpen = openDetailIndex === idx;
                                    return (
                                        <div 
                                            key={idx} 
                                            className={`nd-accordion-item ${isOpen ? 'active' : ''}`}
                                        >
                                            <button 
                                                className="nd-accordion-btn"
                                                onClick={() => toggleDetail(idx)}
                                                aria-expanded={isOpen}
                                            >
                                                <span>{item.q}</span>
                                                <div className="nd-accordion-icon">
                                                    <i className={`fa ${isOpen ? 'fa-minus' : 'fa-plus'}`}></i>
                                                </div>
                                            </button>
                                            <div className={`nd-accordion-collapse ${isOpen ? 'show' : ''}`}>
                                                <div className="nd-accordion-body">
                                                    <p>{item.a}</p>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Gallerysection;
